import { useEffect, useState } from 'react'
import Image from 'next/image'
import styled from 'styled-components'

import { breakpoints } from '@/styles'

import homeMobile from './images/home-mobile.webp'
import homeTablet from './images/home-tablet.webp'
import homeWidescreen from './images/home-widescreen.webp'
import home from './images/home.webp'

const ImageWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  bottom: 0;
  user-select: none;
`

// Convert breakpoint string to number (e.g., "768px" -> 768)
const breakpointToNumber = (breakpoint: string): number => {
  return parseInt(breakpoint.replace('px', ''), 10)
}

const images = [homeWidescreen, home, homeTablet, homeMobile]
const imageBreakpoints = [
  '1440px',
  breakpoints.tabletLandscape,
  breakpoints.phoneMax
]

const MainImage: React.FC<{}> = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState<number | null>(
    null
  )

  useEffect(() => {
    const updateImage = () => {
      const width = window.innerWidth

      // images: [widescreen, desktop, tablet, mobile]
      // breakpoints: ['1440px', '991px', '599px']
      // Logic:
      // - If width > 1440px: use images[0] (widescreen)
      // - If width > 991px && width <= 1440px: use images[1] (desktop)
      // - If width > 599px && width <= 991px: use images[2] (tablet)
      // - If width <= 599px: use images[3] (mobile)

      let imageIndex = images.length - 1 // Start with smallest (mobile)

      // Check from largest to smallest breakpoint
      for (let i = 0; i < imageBreakpoints.length; i++) {
        if (width > breakpointToNumber(imageBreakpoints[i])) {
          imageIndex = i
          break
        }
      }

      setCurrentImageIndex(imageIndex)
    }

    // Initial update
    updateImage()

    // Listen for resize events
    window.addEventListener('resize', updateImage)
    return () => window.removeEventListener('resize', updateImage)
  }, [])

  // Don't render anything until we know which image to show
  if (currentImageIndex === null) {
    return <ImageWrapper />
  }

  const currentImage = images[currentImageIndex]
  const isMobile = currentImageIndex === images.length - 1
  const objectFit = isMobile ? 'contain' : 'cover'

  return (
    <ImageWrapper>
      <Image
        key={`home-page-hero-${currentImageIndex}`}
        src={currentImage}
        alt="liv.rent home page hero"
        priority
        fill
        style={{
          objectFit,
          objectPosition: 'center bottom'
        }}
        placeholder="blur"
      />
    </ImageWrapper>
  )
}

export default MainImage
